// The powers a Durable Power of Attorney can grant, in the conventional
// statutory order. Shared by the generator and the template design so the
// two never drift.
export const POA_POWERS = [
  { id: "realEstate",      label: "Real property transactions",
    desc: "Buy, sell, lease, mortgage, and manage real estate." },
  { id: "personalProperty",label: "Tangible personal property transactions",
    desc: "Buy, sell, and manage vehicles, furnishings, and other personal property." },
  { id: "securities",      label: "Stocks, bonds, and other securities",
    desc: "Buy, sell, and exercise rights in securities and brokerage accounts." },
  { id: "banking",         label: "Banking and financial institution transactions",
    desc: "Open, close, and operate accounts; write checks; make deposits and withdrawals." },
  { id: "business",        label: "Business operating transactions",
    desc: "Operate, manage, and make decisions for a business interest." },
  { id: "insurance",       label: "Insurance and annuity transactions",
    desc: "Purchase, modify, surrender, and make claims on policies and annuities." },
  { id: "estates",         label: "Estate, trust, and other beneficiary transactions",
    desc: "Act on interests in estates, trusts, and other beneficial interests." },
  { id: "claims",          label: "Claims and litigation",
    desc: "Assert, defend, settle, and compromise legal claims on my behalf." },
  { id: "familyMaintenance", label: "Personal and family maintenance",
    desc: "Pay for support, housing, medical care, and living expenses of my family." },
  { id: "governmentBenefits", label: "Benefits from governmental programs",
    desc: "Apply for and manage Social Security, Medicare, Medicaid, and military benefits." },
  { id: "retirement",      label: "Retirement plan transactions",
    desc: "Contribute to, withdraw from, and manage retirement accounts." },
  { id: "taxes",           label: "Tax matters",
    desc: "Prepare, sign, and file tax returns and handle matters with tax authorities." },
  { id: "digitalAssets",   label: "Digital assets and online accounts",
    desc: "Access, manage, and close digital accounts, files, and online records." },
  { id: "safeDeposit",     label: "Safe deposit box access",
    desc: "Enter, add to, and remove contents from any safe deposit box." },
  { id: "gifts",           label: "Making limited gifts",
    desc: "Make gifts consistent with my history of giving and estate plan." },
];
